/*=========================================================================================
  File Name: module-notification-actions.js
  Description: Notification Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
export default {
	NotificationList(state) {
		return state.NotificationList;
	},
	hasNewNotification(state) {
		return state.hasNewNotify;
	},
	countNew(state) {
		return state.countNew;
	}
};
